export abstract class DomainError extends Error {}

export class UnexpectedDomainError extends DomainError {
    constructor(message = "An unexpected error occurred in the domain/application layer.") {
        super(message);
        this.name = 'UnexpectedDomainError';
        Object.setPrototypeOf(this, UnexpectedDomainError.prototype);
    }

    static fromError(error: Error|unknown): UnexpectedDomainError {
        if(error instanceof Error){
            const newMessage = `Unexpected error in domain/application(originally: ${error.name}): ` + error.message
            return new UnexpectedDomainError(newMessage)
        } else {
            console.error(error)
            return new UnexpectedDomainError()
        }
    }
}
